// Optimiser input table — rows of {label, length, qty, note} with
// add/remove. State is owned by the parent modal.
import type { CSSProperties } from "react";

export interface OptRow {
  label: string;
  length: string;
  qty: number;
  note: string;
}

interface Props {
  rows: OptRow[];
  onChange(rows: OptRow[]): void;
}

export function CutOptimizerInput({ rows, onChange }: Props) {
  const update = (i: number, patch: Partial<OptRow>) => {
    onChange(rows.map((r, idx) => (idx === i ? { ...r, ...patch } : r)));
  };
  const remove = (i: number) => onChange(rows.filter((_, idx) => idx !== i));
  const add = () =>
    onChange([...rows, { label: "", length: "", qty: 1, note: "" }]);

  return (
    <>
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 8 }}>
        <div style={{ fontFamily: "var(--bsp-font-display)", fontSize: 11, fontWeight: 700, color: "var(--bsp-blue)", textTransform: "uppercase", letterSpacing: "0.10em" }}>
          Required Cuts
        </div>
        <button type="button" className="btn-sm" onClick={add} style={{ background: "var(--bsp-blue)", color: "#fff", borderColor: "var(--bsp-blue)" }}>
          + Add Cut
        </button>
      </div>
      <div style={{ overflowX: "auto", marginBottom: 14 }}>
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: 12, border: "1px solid var(--bsp-border)", borderRadius: 4, overflow: "hidden" }}>
          <thead>
            <tr style={{ background: "var(--bsp-surface-muted)", borderBottom: "1px solid var(--bsp-border)" }}>
              <th style={hth}>Spool / Label</th>
              <th style={hth}>Length (mm)</th>
              <th style={hth}>Qty</th>
              <th style={hth}>Material / Note</th>
              <th style={{ padding: "7px 10px", width: 30 }} />
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr>
                <td colSpan={5} style={{ padding: 16, textAlign: "center", color: "var(--bsp-fg-muted)" }}>
                  No cuts yet — add a row or load from a job above.
                </td>
              </tr>
            )}
            {rows.map((r, i) => (
              <tr key={i}>
                <td style={tdp}>
                  <input className="cut-inp" value={r.label} placeholder="SP-001" onChange={(e) => update(i, { label: e.target.value })} style={{ width: "100%" }} />
                </td>
                <td style={tdp}>
                  <input className="cut-inp" type="number" min="0" step="1" value={r.length} placeholder="2400" onChange={(e) => update(i, { length: e.target.value })} style={{ width: "100%" }} />
                </td>
                <td style={tdp}>
                  <input className="cut-inp" type="number" min="1" value={r.qty} onChange={(e) => update(i, { qty: Math.max(1, Number(e.target.value) || 1) })} style={{ width: "100%" }} />
                </td>
                <td style={tdp}>
                  <input className="cut-inp" value={r.note} placeholder="Note" onChange={(e) => update(i, { note: e.target.value })} style={{ width: "100%" }} />
                </td>
                <td style={tdp}>
                  <button type="button" className="btn-sm danger" onClick={() => remove(i)} aria-label="Remove row">×</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}

const hth: CSSProperties = {
  padding: "7px 10px",
  textAlign: "left",
  fontSize: 10,
  fontWeight: 700,
  color: "var(--bsp-fg-muted)",
  textTransform: "uppercase",
  letterSpacing: "0.10em",
};

const tdp: CSSProperties = { padding: "4px 6px" };
